import PreviewFooter from "./PreviewFooter";

export default PreviewFooter;